<template>
  <div class="assets">
    <div class="head">
      <img @click="back" src="@/assets/images/back.png" class="arrow_img" />
      <span>{{ $t('lang79') }}</span>
    </div>

    <div class="pd">
      <van-radio-group v-model="radioVal" @change="handleChange">
        <van-cell-group class="vanlist">
          <van-cell class="item" title="English" clickable @click="radio = '1'">
            <template #right-icon>
              <van-radio name="en" icon-size="18px" checked-color="#29b286" />
            </template>
          </van-cell>
          <van-cell class="item" title="中文简体" clickable @click="radio = '2'">
            <template #right-icon>
              <van-radio name="zh-cn" icon-size="18px" checked-color="#29b286" />
            </template>
          </van-cell>
        </van-cell-group>
      </van-radio-group>
    </div>
  </div>
</template>

<script>
import { Locale } from 'vant';
// 引入英文语言包
import enUS from 'vant/es/locale/lang/en-US';
import zhCN from 'vant/lib/locale/lang/zh-CN';
export default {
  data() {
    return {
      radioVal: localStorage.getItem('language') || 'zh-cn',
    };
  },
  mounted() {},
  methods: {
    //返回上一页
    back() {
      this.$router.back();
    },
    handleChange() {
      localStorage.setItem('language', this.radioVal);
      this.$i18n.vm.$forceUpdate();
      this.$i18n.locale = this.radioVal;
      if (this.radioVal == 'en') {
        Locale.use('en-US', enUS);
      } else {
        Locale.use('zh-CN', zhCN);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.head {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(#000, 0.8);
  letter-spacing: 1.5px;
  font-weight: 550;
  background: #fff;
  padding: 14px 0;
  z-index: 99;
  .arrow_img {
    position: absolute;
    left: 20px;
    width: 10px;
    height: 16px;
    // transform: translate(0, -50%);
  }
}
.f-sb {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.f-c {
  display: flex;
  justify-content: space-between;
}
.f-sa {
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.f-sb-n {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
}
.f-col {
  display: flex;
  flex-direction: column;
}
.assets {
  min-height: 100vh;
  padding: 60px 0 0;

  .pd {
    margin: 14px;
    background-color: #fff;
    .vanlist {
      padding: 20px;
      border-radius: 20px;
      box-sizing: border-box;
      border: none !important;

      .item {
        padding: 12px 0 !important;
        border-bottom: 0.5px solid rgba(190, 190, 190, 0.15);
      }
    }
  }
}
::v-deep .van-hairline--left::after {
  border-left-width: 0.005px !important;
}
::v-deep .van-hairline--top-bottom::after,
::v-deep.van-hairline-unset--top-bottom::after {
  border: none;
}
</style>